import { isBrowser } from '@websolutespa/bom-core';
import { createStore, useStore } from 'zustand';
import { createJSONStorage, persist, StateStorage } from 'zustand/middleware';

type Props = {
  reducedMotion: boolean;
};

type Actions = {
  setReducedMotion(reducedMotion: boolean): void;
  toggleReducedMotion(): void;
};

type State = Props & {
  actions: Actions;
};

const QUERY = '(prefers-reduced-motion: no-preference)';

export function getPreferredReducedMotion(): boolean {
  return (isBrowser && !window.matchMedia(QUERY).matches);
}

const updateClassList = (reducedMotion: boolean) => {
  // console.log('useReducedMotion.updateClassList', reducedMotion);
  if (isBrowser) {
    document.documentElement.classList.toggle('--reduced-motion', reducedMotion);
    document.documentElement.classList.toggle('--motion', !reducedMotion);
  }
};

const createReducedMotionStore = ({
  name,
  storage,
  ...initialState
}: {
  name: string,
  storage?: StateStorage
} & Partial<Props>) => {
  const defaultState: Props = {
    reducedMotion: true,
  };
  const useStore = createStore<State>()(persist(
    (set, get) => ({
      ...defaultState,
      ...initialState,
      actions: {
        setReducedMotion: (reducedMotion: boolean) => {
          updateClassList(reducedMotion);
          set(state => ({ reducedMotion }));
        },
        toggleReducedMotion: () => {
          const state = get();
          const newReducedMotion = !state.reducedMotion;
          updateClassList(newReducedMotion);
          set(state => ({ reducedMotion: newReducedMotion }));
        },
      },
    }),
    {
      name,
      storage: createJSONStorage(() => storage || sessionStorage),
      merge: (persistedState: any, currentState: State) => {
        const newReducedMotion = persistedState?.reducedMotion || getPreferredReducedMotion();
        updateClassList(newReducedMotion);
        currentState.reducedMotion = newReducedMotion;
        // console.log('useReducedMotion.hydration', currentState);
        return currentState;
      },
      // getStorage: () => {
      //  return storage || sessionStorage;
      // },
      // onRehydrateStorage: () => () => {
      //  console.log('onRehydrateStorage', useStore, useStore.getState());
      // },
    }
  ));
  return useStore;
};

let reducedMotionSingletonStore_: ReturnType<typeof createReducedMotionStore> | undefined;
const createReducedMotionSingletonStore = () => {
  reducedMotionSingletonStore_ = reducedMotionSingletonStore_ || createReducedMotionStore({ name: 'prefers-reduced-motion' });
  return reducedMotionSingletonStore_;
};

export function useReducedMotion<T>(selector: (state: State) => T): T {
  return useStore(createReducedMotionSingletonStore(), selector);
}

/*
.--reduced-motion { }
@media (prefers-reduced-motion: reduced) {
}
.--motion { }
@media (prefers-reduced-motion: no-preference) {
}
*/
